import { Col, Row } from "reactstrap";
import MenuWizard from "../shared/menus/menuWizard/MenuWizard";
import { useState } from "react";
import Contacto from "./Contacto";
import UnidadesDeNegocio from "./UnidadesDeNegocio";
import PagosFacturacion from "./PagosFacturacion";
import UsuariosAccesos from "./UsuariosAccesos";
import Asistencia from "./Asistencia";
import { pages } from "./utils";

export default function Wizard() {
    const [activePage, setActivePage] = useState(pages.contacto);

    return (
        <Row>
            <Col>
                <h4>Asistente de configuración de la organización</h4>
            </Col>
            <Row>
                <Col md={3}>
                    <MenuWizard activePage={activePage} setActivePage={setActivePage} />
                </Col>
                <Col className="mt-4">
                    {
                        activePage === pages.contacto && <Contacto />
                    }
                    {
                        activePage === pages.pagos && <PagosFacturacion />
                    }
                    {
                        activePage === pages.unidades && <UnidadesDeNegocio />
                    }
                    {
                        activePage === pages.usuarios && <UsuariosAccesos />
                    }
                    {
                        activePage === pages.asistencia && <Asistencia />
                    }
                </Col>
            </Row>
        </Row>
    )
}